<span [class]="'tag tag--' + variant()">
  <ng-content></ng-content>
  <span class="tag-label">{{ label() }}</span>
</span>
